import i18n from '@/js/i18n';
import store from '@/store';
import { removeCurrentLanguage, getUrlContext } from '@/helpers/AppHelpers';

const getPageNav = function (node) {
  if (i18n.locale == 'en' && node.noeudAnglais && node.noeudAnglais.length > 0) {
    return node.noeudAnglais;
  }
  return node['@name'];
};

const getPathAutreLangue = function (node) {
  if (i18n.locale != 'en' && node.noeudAnglais && node.noeudAnglais.length > 0) {
    return node.noeudAnglais;
  }
  return node['@name'];
};

const getPageNavTraite = function (pagenav, result = [], parentNode = null) {
  if (pagenav['@name'] !== 'api') {
    if (pagenav['@nodes']) {
      pagenav['@nodes'].forEach((name) => {
        const nodeParent = getNodeValeurRoute(pagenav[name], parentNode);
        result.push(nodeParent);
        getPageNavTraite(pagenav[name], result, nodeParent);
      });
    } else {
      // TODO: Corriger l'erreur. 'name' est inexistant à cet endroit
      // eslint-disable-next-line no-restricted-globals
      result.push(getNodeValeurRoute(pagenav[name], parentNode));
    }
  }
};

const getNodeValeurRoute = function (node, nodeParent = null) {
  let pathBase = '/';
  let pathAutreLangueBase = '/';
  if (nodeParent) {
    pathBase = `${nodeParent['@path']}/`;
    pathAutreLangueBase = `${nodeParent.pathAutreLangue}/`;
  }
  return {
    '@id': node['@id'],
    '@path': pathBase + getPageNav(node),
    pathAutreLangue: pathAutreLangueBase + getPathAutreLangue(node),
    websitePath: node['@path'],
    title: node.title,
    menuTitle: node.afficherDansMenu === 'true' ? node.menuTitle : null,
  };
};

const state = {
  routes: [],
  currentRoute: '',
  routerHistory: [],
  pathTraduit: '',
  baseName: process.env.VUE_APP_SITE_BASENAME,
};

const getters = {
  routes() {
    return state.routes;
  },

  getPreviousRoute: (state) => {
    const historyLen = state.routerHistory.length;
    if (historyLen < 2) return null;
    return state.routerHistory[historyLen - 2];
  },
  getRouteByPath: (state) => (path) => {
    let pathNettoye = path.split(state.baseName).pop();
    pathNettoye = removeCurrentLanguage(pathNettoye, i18n.locale);
    // Retirer ".html" ou "/" à la fin de l'URL
    pathNettoye = pathNettoye.replace(/(\/|.html)$/, '');

    return state.routes.find(
      (route) =>
        pathNettoye === route.websitePath.split(state.baseName).pop() ||
        pathNettoye === route['@path']
    );
  },
  getUrlFromWebsitePath: (state) => (websitePath) => {
    const routeData = getters.getRouteFromAttribute(state, websitePath, 'websitePath');
    if (routeData == null) return '';

    return routeData['@path'];
  },
  getRouteFromAttribute(state, value, attribute) {
    return state.routes.find((route) => {
      return (
        route[attribute] &&
        (route[attribute].toLowerCase() === value.toLowerCase() ||
          route[attribute].toLowerCase() ===
            process.env.VUE_APP_SITE_BASENAME + value.toLowerCase() ||
          process.env.VUE_APP_SITE_BASENAME + route[attribute].toLowerCase() ===
            value.toLowerCase())
      );
    });
  },
  getPathAutreLangue: (state) => (pathLangueCourante) => {
    const routeCourante = state.routes.find((route) => route['@path'] == pathLangueCourante);
    if (!routeCourante) {
      console.log(`getPathAutreLangue: Route inexistante: ${pathLangueCourante}`);
      return '';
    }
    return routeCourante.pathAutreLangue;
  },

  getWebsitePathByUuid: (state) => (uuid) => {
    const route = state.routes ? state.routes.find((uneRoute) => uneRoute['@id'] == uuid) : null;
    if (!route) {
      console.log(`Route inexistante. Uuid:${uuid}`);
      return '';
    }
    return route.websitePath;
  },
};

const actions = {
  async initRoutes(context, language = null) {
    let allRoutes = [];
    const currentLanguage = language || i18n.locale;

    const pagenavResponse = await fetch(
      getUrlContext(
        `${
          process.env.VUE_APP_REST_PAGENAV + process.env.VUE_APP_SITE_BASENAME
        }?lang=${currentLanguage}`
      )
    );
    const pagenav = await pagenavResponse.json();
    const newPagenav = [
      {
        '@id': pagenav['@id'],
        '@path': '/',
        pathAutreLangue: '',
        websitePath: pagenav['@path'],
        title: pagenav.title,
        protection: null,
      },
    ];

    const routes = [];
    getPageNavTraite(pagenav, routes);

    allRoutes = newPagenav.concat(routes);

    context.commit('SET_ROUTES', allRoutes);
  },
};

const mutations = {
  SET_ROUTES(state, value) {
    state.routes = value;
  },
  ADD_ROUTE(state, value) {
    state.routerHistory.push(value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
